<template>
  <!--
    Start Home Page
    this page contain steps from step 1 to step 6
  -->
  <v-container class="pt-5 pb-15" style="max-width: 900px;">
    <!--Start Top Bar Of Stepts-->
    <top-bar-component :step="this.step" :progressVal="this.progressVal" />
    <!--End Top Bar Of Stepts-->

    <!--Start Steps Card-->
    <v-card elevation="0" tile outlined class="mt-9">
      <v-window v-model="step" touchless>
        <!--Start Step1-->
        <v-window-item :value="1">
          <step-1-component ref="step1" />
        </v-window-item>
        <!--End Step1-->

        <!--Start step 2-->
        <v-window-item :value="2">
          <step-2-component v-if="step===2" />
        </v-window-item>
        <!--End step 2-->

        <!--Start step 3-->
        <v-window-item :value="3">
          <step-3-component ref="step3" />
        </v-window-item>
        <!--End step 3-->

        <!--Start step 4-->
        <v-window-item :value="4">
          <step-4-component />
        </v-window-item>
        <!--End step 4-->

        <!--Start step 5-->
        <v-window-item :value="5">
          <step-5-component ref="step5" />
        </v-window-item>
        <!--End step 5-->

        <!--Start step 6-->
        <v-window-item :value="6">
          <step-6-component @edit="edit" />
        </v-window-item>
        <!--End step 6-->
      </v-window>

      <!--Start Next, Back and Skip Button-->
      <v-card-actions v-if="step !== 6" class="px-4 py-2">
        <v-btn
          v-if="step !== 1"
          outlined
          large
          tile
          color="warning"
          class="px-7"
          @click="prev(step)"
        >
          {{ $t("generic.lang_back") }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          large
          tile
          class="px-7"
          color="success"
          depressed
          :disabled="!isNextBtn"
          @click="next(step)"
        >
          {{
            nextAndSkip == "SKIP"
              ? $t("generic.lang_skip")
              : $t("generic.lang_next")
          }}
        </v-btn>
      </v-card-actions>
      <!--End Next, Back and Skip Button-->
    </v-card>
  </v-container>
  <!--End Home Page-->
</template>

<script>
import TopBarComponent from "@/components/stepsBar/TopBarComponent.vue";
import Step1Component from "@/components/steps/Step1Component.vue";
import Step2Component from "@/components/steps/Step2Component.vue";
import Step3Component from "@/components/steps/Step3Component.vue";
import Step4Component from "@/components/steps/Step4Component.vue";
import Step5Component from "@/components/steps/Step5Component.vue";
import Step6Component from "@/components/steps/Step6Component.vue";

/*import plugins*/
import { createNamespacedHelpers } from "vuex";

export default {
  name: "Home",

  components: {
    TopBarComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    Step5Component,
    Step6Component,
  },

  data: () => ({
    step: 1,
    progressVal: 0,
  }),

  computed: {
    ...createNamespacedHelpers("config").mapGetters(["isNextBtn"]),
    ...createNamespacedHelpers("dateTime").mapGetters(["date", "time"]),
    ...createNamespacedHelpers("reservationTypes").mapGetters([
      "skipTables",
      "skipItems",
    ]),
    ...createNamespacedHelpers("tables").mapState(["tables"]),
    ...createNamespacedHelpers("items").mapState(["selectedItems"]),

    nextAndSkip() {
      if (
        (Array.isArray(this.tables) && !this.tables.length && this.step == 3) ||
        (Array.isArray(this.selectedItems) && !this.selectedItems.length && this.step == 4)
      ) {
        return "SKIP";
      }

      return "NEXT";
    },
  },

  watch: {
    step(val) {
      if (val == 1) {
        this.$store.dispatch("reservationTypes/fetchReservationTypes");
      } else if (val == 2) {
        this.$store.commit("config/isNextBtn", this.validStep2());
      } else if (val == 3) {
        this.$store.dispatch("tables/fetchRooms");
      } else if (val == 4) {
        this.$store.dispatch("items/fetchMenuTypes");
      } else {
        return;
      }
    },
  },

  mounted() {
    this.$store.dispatch("reservationTypes/fetchReservationTypes");
  },

  methods: {
    next(val) {
      if (val == 1) {
        if (this.validStep1()) {
          this.step = 2;
          this.progressVal = 20;
        }
        return;
      }

      if (val == 2) {
        if (this.skipItems && this.skipTables) {
          this.step = 5;
          this.progressVal = 80;
        } else if (this.skipTables) {
          this.step = 4;
          this.progressVal = 60;
        } else if (this.validStep2()) {
          this.step = 3;
          this.progressVal = 40;
        }
        return;
      }

      if (val == 3) {
        if (this.validStep3()) {
          if (this.skipItems) {
            this.step = 5;
            this.progressVal = 80;
          } else {
            this.step = 4;
            this.progressVal = 60;
          }
        }
        return;
      }

      if (val == 4) {
        this.step = 5;
        this.progressVal = 80;
        return;
      }

      if (val == 5) {
        if (this.validStep5()) {
          this.step = 6;
          this.progressVal = 100;
        }
        return;
      }
    },

    prev(val) {
      if (val == 2) {
        this.step = 1;
        this.progressVal = 0;
        return;
      }

      if (val == 3) {
        this.step = 2;
        this.progressVal = 20;
        return;
      }

      if (val == 4) {
        if (this.skipTables) {
          this.step = 2;
          this.progressVal = 20;
        } else {
          this.step = 3;
          this.progressVal = 40;
        }
        return;
      }

      if (val == 5) {
        if (this.skipItems && this.skipTables) {
          this.step = 2;
          this.progressVal = 20;
        } else if (this.skipItems) {
          this.step = 3;
          this.progressVal = 40;
        } else {
          this.step = 4;
          this.progressVal = 60;
        }
        return;
      }
    },

    validStep1() {
      if (!this.$refs.step1.validate()) {
        return false;
      } else {
        return true;
      }
    },

    validStep2() {
      return !!this.date && !!this.time;
    },
    
    validStep3() {
      if (!this.$refs.step3.checkMaxPersons()) {
        return false;
      } else {
        return true;
      }
    },

    validStep5() {
      if (!this.$refs.step5.validate()) {
        return false;
      } else {
        return true;
      }
    },

    edit() {
      this.step = 1;
      this.progressVal = 0;
    },
  },
};
</script>
